import { render } from "./Ortho3dItemList.vue?vue&type=template&id=19f578c9&scoped=true"
import script from "./Ortho3dItemList.vue?vue&type=script&lang=js"
export * from "./Ortho3dItemList.vue?vue&type=script&lang=js"

import "./Ortho3dItemList.vue?vue&type=style&index=0&id=19f578c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f578c9"]])

export default __exports__